import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eBaoCaoThongKeActionsObj = {
    SELECTED_MENU: ""
}

export const eBaoCaoThongKeActionIds = generateActionTypeIds(eBaoCaoThongKeActionsObj, "BAO_CAO_THONG_KE");
export type IBaoCaoThongKeActionTypes = IGenericActionType<typeof eBaoCaoThongKeActionsObj, "BAO_CAO_THONG_KE">;